'use client';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Link from 'next/link';

export default function FinanceHero({ block, position }) {
  const {
    background_image,
    cta,
    finance_logo,
    pretext,
    title,
    toggle_id_me,
    toggle_small_image,
    background_color_picker,
    _metadata
  } = block.finance_hero;

  const toggled = toggle_id_me;
  const smallImage = toggle_small_image;

  const [developDomain, setDevelopDomain] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      setDevelopDomain(
        hostname.indexOf('beta') !== -1 ||
          hostname.indexOf('alpha') !== -1 ||
          hostname.indexOf('localhost') !== -1 ||
          hostname.indexOf('vercel') !== -1
      );
    }
  }, []);

  useEffect(() => {
    if (developDomain !== null && typeof window['affirm'] == 'undefined') {
      const affirmApiKey = developDomain
        ? 'FWUPRAEPEJ8CDZUV'
        : '2LSY5K7PY0C2IZQ7';
      const affirmScript = developDomain
        ? 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
        : 'https://cdn1.affirm.com/js/v2/affirm.js';
      var _affirm_config = {
        public_api_key: `${affirmApiKey}`,
        script: `${affirmScript}`,
        locale: 'en_US',
        country_code: 'USA'
      };

      (function (m, g, n, d, a, e, h, c) {
        var b = m[n] || {},
          k = document.createElement(e),
          p = document.getElementsByTagName(e)[0],
          l = function (a, b, c) {
            return function () {
              a[b]._.push([c, arguments]);
            };
          };
        b[d] = l(b, d, 'set');
        var f = b[d];
        b[a] = {};
        b[a]._ = [];
        f._ = [];
        b._ = [];
        b[a][h] = l(b, a, h);
        b[c] = function () {
          b._.push([h, arguments]);
        };
        a = 0;
        for (
          c =
            'set add save post open empty reset on off trigger ready setProduct'.split(
              ' '
            );
          a < c.length;
          a++
        )
          f[c[a]] = l(b, d, c[a]);
        a = 0;
        for (c = ['get', 'token', 'url', 'items']; a < c.length; a++)
          f[c[a]] = function () {};
        k.async = !0;
        k.src = g[e];
        p.parentNode.insertBefore(k, p);
        delete g[e];
        f(g);
        m[n] = b;
      })(
        window,
        _affirm_config,
        'affirm',
        'checkout',
        'ui',
        'script',
        'ready',
        'jsReady'
      );
    }
  }, [developDomain]);

  useEffect(() => {
    if (typeof window['affirm'] !== 'undefined') {
      window.affirm.ui.ready(function () {
        window.affirm.ui.refresh();
      });
    }
  }, []);

  const desktopImage = background_image.desktop;

  return (
    <section
      id={_metadata.uid + '_' + position}
      className={`relative bg-[${background_color_picker}]`}
      data-optimizely="finance-hero"
      data-name="finance-hero"
    >
      <div
        className={`absolute top-0 z-10 h-full w-full bg-black opacity-30`}
      ></div>
      <Image
        src={desktopImage.url}
        width={desktopImage.dimension.width}
        height="740"
        sizes="100vw"
        priority
        alt={desktopImage.title.replace(/\.[^/.]+$/, '')}
        className={`${smallImage ? 'h-[280px]' : 'h-[480px] min-[990px]:h-[620px] lg:h-[740px]'} w-full overflow-hidden object-cover`}
      />
      <div className={`relative`} />
      <div className="absolute top-0 bottom-0 z-20 flex w-full flex-wrap items-center justify-center">
        <div>
          <div className="px-5 text-center text-white sm:px-15">
            {finance_logo?.url && (
              <Image
                src={finance_logo.url}
                width="255"
                height="48"
                sizes="(min-width: 640px) 255px, 180px"
                alt={finance_logo.title.replace(/\.[^/.]+$/, '')}
                className="mx-auto mb-9 h-[24px] w-full lg:mb-10 lg:h-[48px]"
              />
            )}
            {toggled ? (
              <h1 className="h3 sm:h1 block">{title}</h1>
            ) : (
              <p className="preheading-s sm:preheading-r mb-4 block lg:mb-5">
                {pretext}
              </p>
            )}
            {toggled ? (
              <p className="preheading-s sm:preheading-r mb-4 block lg:mb-5">
                {pretext}
              </p>
            ) : (
              <h1 className="h3 sm:h1 block">{title}</h1>
            )}
          </div>
          <div className="mt-12 text-center">
            {cta.label && !cta?.external_link?.href.length ? (
              <>
                {cta.label ? (
                  <button
                    id="finance-msg-finance-hero"
                    className="affirm-site-modal btn btn-primary"
                    data-page-type="landing"
                    data-affirm-color="black"
                    aria-label="See if you qualify (opens in modal)"
                  >
                    {cta.label}
                  </button>
                ) : (
                  ''
                )}
              </>
            ) : null}
            {cta.label && cta?.external_link?.href.length > 0 ? (
              <>
                <div id="external-link" className="h-0 w-0 opacity-0"></div>
                <a
                  href={cta?.external_link?.href}
                  id={cta?.external_link?.title}
                  target="_blank"
                  rel="external noreferrer noopener"
                >
                  <button className="btn-primary btn">{cta.label}</button>
                </a>
              </>
            ) : null}
            {toggled ? (
              <Link
                href={`https://discountify.id.me/oauth/groups/leesa-us-store`}
                className="id-me-button"
                target="_blank"
                rel="noindex noreferrer"
              >
                <Image
                  className="mx-auto h-[48px] w-[236px]"
                  height={48}
                  width={236}
                  src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg"
                  alt="ID.me Logo"
                />
              </Link>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
